import styled from 'styled-components';

export const CardContainer = styled.div`
  border: 1px solid rgba(0, 0, 0, 0.12);
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  background-color: transparent;
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;

  @media ${(props) => props.theme.screen.md} {
    padding: 40px 33px;
    display: grid;
    grid-template-columns: 250px 1fr;
    gap: 52px;
  }
`;

export const LogoSection = styled.div`
  display: flex;
  flex-direction: column;
`;

export const LogoWrapper = styled.div`
  background-color: ${(props) => props.theme.colors.white};
  width: 200px;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  align-self: center;

  @media ${(props) => props.theme.screen.md} {
    width: 250px;
    height: 250px;
    align-self: flex-start;
  }
`;

export const OrganizationLogo = styled.img`
  width: 214px;
  height: 214px;
  object-fit: cover;
`;

export const FeaturedBadge = styled.div`
  font-family: ${(props) => props.theme.fontFamilies.inter};
  font-size: 14px;
  line-height: 121%;

  background-color: ${(props) => props.theme.colors.black};
  color: ${(props) => props.theme.colors.white};
  padding: 4px 8px;
  border-radius: 4px;
  width: fit-content;
`;

export const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  min-width: 0;
`;

export const OrganizationName = styled.div`
  * {
    font-family: ${(props) => props.theme.fontFamilies.vollkorn};
    font-weight: 400;
    font-size: 20px;
    line-height: 121%;
    letter-spacing: 0%;
    margin: 0;
    color: ${(props) => props.theme.colors.black};

    @media ${(props) => props.theme.screen.md} {
      font-size: 24px;
    }
  }
`;

export const Subtitle = styled.h4`
  font-size: 16px;

  @media ${(props) => props.theme.screen.md} {
    font-size: 18px;
  }
`;

export const BodyText = styled.p`
  font-family: ${(props) => props.theme.fontFamilies.sfPro};
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0%;
  margin: 0;
  color: ${(props) => props.theme.colors.black};

  @media ${(props) => props.theme.screen.md} {
    font-size: 16px;
  }
`;

export const CTALink = styled.a`
  font-family: ${(props) => props.theme.fontFamilies.sfPro};
  font-weight: 510;
  font-size: 14px;
  line-height: 150%;
  letter-spacing: 0%;
  text-decoration: underline;
  text-decoration-style: solid;
  color: ${(props) => props.theme.colors.black};
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  width: fit-content;
  margin: 0;
  align-self: flex-end;

  @media ${(props) => props.theme.screen.md} {
    font-size: 16px;
  }

  &:hover {
    opacity: 0.8;
  }
`;
